// noinspection JSUnusedGlobalSymbols

import {
  GuildNames,
  MintTxStatuses,
  NFTColors,
  NFTRank,
  NFTRankNames,
  NftTrait
} from '../index';
import * as mongoose from 'mongoose';

interface RawNft {
  _id: mongoose.Schema.Types.ObjectId | string;
  token: string;
  minted: boolean;
  price: number;
  level: number;
  rankName: NFTRankNames;
  guild: GuildNames;
  colors: NFTColors;
  name: string;
  image: string;
  traits: NftTrait[];
}

export interface API_NftDetails extends RawNft {
  _id: string;
  belongsToSelf: boolean;
  failed: boolean;
  pending: boolean | undefined;
  rank: NFTRank;
}

export interface API_GetFreeNft {
  nft: API_NftDetails;
  noMore: boolean;
}

interface API_NftStatus {
  nft: API_NftDetails;
  status: MintTxStatuses;
}

export type API_NftStatusResponse = API_NftStatus | { needUpdate: boolean };

export interface API_OwnNft {
  _id: string;
  token: string;
  minted: boolean;
  price: number;
  colors: NFTColors;
  rankName: NFTRankNames;
  guild: GuildNames;
  name: string;
  level: number;
  image: string;
  rank: NFTRank;
  failed: boolean;
  pending: boolean;
}

export type API_GetOwnNftResponse = API_OwnNft[];

export const nftDetailsToOwn = (
  nft: API_NftDetails,
  failed: boolean = false,
  pending: boolean = false
): API_OwnNft => ({
  name: nft.name,
  rankName: nft.rankName,
  rank: nft.rank,
  image: nft.image,
  minted: nft.minted,
  price: nft.price,
  colors: nft.colors,
  level: nft.level,
  guild: nft.guild,
  _id: nft._id.toString(),
  token: nft.token,
  failed,
  pending
});
